import { AfterViewInit, Component, inject } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { AuthService } from '@static/services/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { UserSettingsComponent } from '@shared/dialogs/user-settings/user-settings.component';
import { environment } from '@environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AdminService } from '@shared/services/admin.service';
import { SnackService } from '@static/services/snack.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Helper } from '@static/helpers';
import { UploadListComponent } from '@shared/dialogs/upload-list/upload-list.component';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    MatMenuModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  providers: []
})
export class HeaderComponent implements AfterViewInit {
  private _router: Router = inject(Router);
  public authService: AuthService = inject(AuthService);
  private _dialog: MatDialog = inject(MatDialog);
  private _adminService: AdminService = inject(AdminService);
  private _snackService: SnackService = inject(SnackService);

  public version: string;

  public isSiteAdmin?: boolean;
  public isGlobalAdmin?: boolean;
  public loginDisplay?: boolean;
  public username?: string;
  public trueUsername?: string;

  public siteLogo: string;

  constructor() {
    this.version = environment.version;
    this.siteLogo = `${environment.backendUri}/${this.version}/site/logo`;
  }

  ngAfterViewInit(): void {
    this.isSiteAdmin = this.authService.isSiteAdmin;
    this.isGlobalAdmin = this.authService.isGlobalAdmin;
    this.loginDisplay = this.authService.loginDisplay;
    this.username = this.authService.username;
  }

  /**
   * Open the user settings dialog
   */
  public openUserSettings(): void {
    this._dialog.open(UserSettingsComponent, {
      minWidth: '30vw',
      maxWidth: '90vw',
    });
  }

  /**
   * Export the user access list
   */
  public exportUserAccess(): void {
    this._adminService.exportUserAccessList();
  }

  /**
   * Export the project access list
   */
  public exportProjectAccess(): void {
    this._adminService.exportProjectAccessList();
  }

  /**
   * Navigate to another page
   *
   * @param path  location to navigate to
   */
  public navigate(path: string): void {
    this._router.navigate([path]);
  }

  /**
   * Send an error report with some debug info
   */
  public sendErrorReport(): void {
    const subject = 'Ctrl key Issue Report';
    let body = `%0A%0A
      ~~~~~~~~~~ DEBUG INFO ~~~~~~~~~~%0A
      User: ${this.authService.username} (${this.authService.email})%0A
      Site: ${window.location.hostname}%0A%0A`;

    const messages = this._snackService.getMessages();

    messages.forEach((msg) => {
      body = body.concat(`${msg.msg}%0A`);
      if (Helper.isDefined(msg.err)) {
        const httpErr = msg.err as HttpErrorResponse;
        if ('status' in httpErr && httpErr.status !== undefined && 'message' in httpErr && httpErr.message !== undefined) {
          body = body.concat(`${httpErr.status} (${httpErr.statusText}) - ${httpErr.message}%0A`);
        }
        const err = msg.err as Error;
        if ('stack' in err && err.stack !== undefined) body = body.concat(`${err.stack.replace(/[\r\n]+/g, "%0A>%09")}%0A`);
      }
      body = body.concat(`%0A`);
    });

    window.open(`mailto:support@ctrlkey.au?subject=${subject}&body=${body}`, '_self');
  }

  /**
   * Open the upload list dialog
   */
  protected openUploadList(): void {
    this._dialog.open(UploadListComponent, {
      minWidth: '30vw'
    });
  }

}
